import React from 'react';
import ProgressStep from './ProgressStep';
import transitionIcon from '../../../../assets/transition.svg';

interface ProgressBarProps {
  currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  const steps = [
    'Enter intent signal',
    'Keywords',
    'ICP rulesets'
  ];

  return (
    <div className="px-6 py-[14px] border-b border-[#EEEEEE]">
      <div className="flex items-center gap-6">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <ProgressStep
              label={step}
              isCompleted={index < currentStep}
              isActive={index === currentStep}
              number={index + 1}
            />
            {index < steps.length - 1 && (
              <span className={`${index < currentStep ? 'text-[#222222]' : 'text-[#75757599]'}`}>
                <img 
                  src={transitionIcon} 
                  alt="transition"
                  className={`${index < currentStep ? 'opacity-100' : 'opacity-60'}`}
                />
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar; 